/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DataCentersEnum } from './dataCentersEnum';


export interface EnforcementTypeSelection { 
    noSubscriptions?: boolean;
    noSubscriptionsVm?: boolean;
    noSubscriptionsTiB?: Array<DataCentersEnum>;
    overageVm?: boolean;
    overageTiB?: Array<DataCentersEnum>;
}

